import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {  Router } from '@angular/router';

@Component({
    selector: 'app-dialog-back',
    templateUrl: './dialog-back.component.html',
    styleUrls: ['./dialog-back.component.scss'],
    standalone: false
})
export class DialogBackComponent implements OnInit {

  dataSource: string = '';

  constructor(
    public dialogRef: MatDialogRef<DialogBackComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router:  Router) { }

  ngOnInit(): void {
    this.dataSource = this.data.dialogText;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onBackClick(): void {
    this.router.navigate([this.data.backUrl]);
    this.dialogRef.close();
  }
}
